import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { Layout } from "./Layout";

const Home = React.lazy(() => import("./pages/Home"));
const About = React.lazy(() => import("./pages/About"));
const Product = React.lazy(() => import("./pages/Product"));
const Service = React.lazy(() => import("./pages/Service"));
const Contact = React.lazy(() => import("./pages/Contact"));
const ProductDetail = React.lazy(() => import("./pages/ProductDetail"));

const Routeing: React.FC = () => {
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <Routes>
                <Route element={<Layout />}>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/product" element={<Product />} />
                    <Route path="/service" element={<Service />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/product/product_detail/*" element={<ProductDetail />} />
                </Route>
            </Routes>
        </Suspense>
    );
};

export default Routeing;
